import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import ReactPlayer from 'react-player';
import { DocumentViewer } from 'react-documents';
import styles from './photoCarousel.module.scss';
import Clickable from '../clickable/Clickable';
import Button from '../button/button';
import FormattedMessageWithClass from '../formattedMessageWithClass';
import { renderInfoForType } from '../../utils/helpers';
import ZoomImage from './ZoomImage';

const NextPhotoArrow = ({ className, onClick }) => (
  <Clickable
    className={`${className} ${styles.nextArrow}`}
    onClick={onClick}
  />
);

NextPhotoArrow.defaultProps = {
  className: '',
  onClick: () => {}
};

NextPhotoArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};


const PrevPhotoArrow = ({ className, onClick }) => (
  <Clickable
    className={`${className} ${styles.prevArrow}`}
    onClick={onClick}
  />
);

PrevPhotoArrow.defaultProps = {
  className: '',
  onClick: () => {}
};

PrevPhotoArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};


class FileSlider extends Component {
  constructor(props) {
    super(props);
    this.mainCarousel = React.createRef();
    this.imageNav = React.createRef();

    this.state = {
      currIndex: 0
    };
  }

  handlePause = (i) => {
    const { currIndex } = this.state;

    if (i === currIndex) {
      return true;
    }
      return false;
  };

  render() {
    const { photos, initialSlide, showAttachFieldName, reqAttachmentDetails, badgeAttachmentDetails, formsDetails } = this.props;
    const attachments = photos?.filter(e => ((e.url && e.url?.length > 0) || (e.preview && e.preview.length > 0) || (e.image && e.image.length)));
    const renderFiles = (photo, i) => {
      const fileExtension = (photo?.file_name || photo?.name)?.split('.').pop();
      const isImage = ((photo.type || photo.content_type).includes('image')) && (!(photo.type || photo.content_type).includes('image/tiff'));
      const isImageSVG = ((photo.type || photo.content_type).includes('image')) && (photo.type || photo.content_type).includes('image/svg+xml');
      const isDocument = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'csv'].includes(fileExtension);
      const fileExtension2 = (photo.type || photo.content_type).split('/').shift();
      const isAudioVideo = ['audio', 'video'].includes(fileExtension2);
      const badgeAttachmentArray = Object.values(badgeAttachmentDetails || {});
      const matchingBadgeAttachment = badgeAttachmentArray.find(
        cc => cc.attachment[0] === photo.attachment_id
      );
      const badgeExpiryDate = matchingBadgeAttachment?.expiry_date || null;
      if (isImage) {
      return (
              <>
                <div className={styles.slider}>
                  <div className={styles.slideContainer} style={{ width: formsDetails && '100%',
                    maxWidth: formsDetails && '100%',
                    marginBottom: formsDetails && '10px' }}>
                  <h3>
                    {showAttachFieldName
                      ? (photo.attachmentFieldName || photo.file_name || photo.name)
                      : (photo.file_name || photo.name)
                    }
                    {reqAttachmentDetails?.req_attachments_dates?.[`${photo.attachmentFieldName}_date`] && (
                      <span style={{ fontSize: '16px', fontWeight: 'normal' }}> (
                        <FormattedMessageWithClass
                          tagname="span"
                          id="exipres.on"
                          defaultMessage={'Expires On'}
                        />
                        : {renderInfoForType(
                            { type: 'date' },
                            reqAttachmentDetails.req_attachments_dates[`${photo.attachmentFieldName}_date`]
                          )}
                      )
                      </span>
                    )}
                    {badgeExpiryDate !== null && (
                      <span style={{ fontSize: '16px', fontWeight: 'normal' }}> (
                        <FormattedMessageWithClass
                          tagname="span"
                          id="exipres.on"
                          defaultMessage={'Expires On'}
                          />
                          : {renderInfoForType({ type: 'date' }, badgeExpiryDate)}
                          )
                      </span>
                    )}
                  </h3>
                  <a href={photo.url || photo.preview || photo.image} target="_blank" rel="noopener noreferrer">
                    <Button
                      translationID="documents.version.download"
                      defaultText="Download"
                      action="secondary"
                      style={{ color: '#e6eaee' }}
                      formsDetails={formsDetails}
                    />
                  </a>
                  </div>
                  {(formsDetails && !isImageSVG) ? (
                    <ZoomImage
                      image={photo.preview || photo.url || photo.image}
                    />
                  ) : (
                    <div className={styles.verifiedContainer}>
                      <img src={photo.preview || photo.url || photo.image} alt={`attachment-${photo.file_name || photo.name || photo.image}`}
                       style={{ width: showAttachFieldName ? '100%' : 'auto' }} />
                    </div>
                  )}
                </div>
              </>);
      } if (isDocument) {
        return (
          <div>
            <div className={styles.loadingText}>
              Loading File...
            </div>
            <div className={styles.slider}>
                <div className="d-flex justify-content-between" style={{ width: formsDetails && '100%',
                    maxWidth: formsDetails && '100%',
                    marginBottom: formsDetails && '10px' }}>
                  <h3>
                    {showAttachFieldName
                      ? (photo.attachmentFieldName || photo.file_name || photo.name)
                      : (photo.file_name || photo.name)
                    }
                    {reqAttachmentDetails?.req_attachments_dates?.[`${photo.attachmentFieldName}_date`] && (
                      <span style={{ fontSize: '16px', fontWeight: 'normal' }}> (
                        <FormattedMessageWithClass
                          tagname="span"
                          id="exipres.on"
                          defaultMessage={'Expires On'}
                        />
                        : {renderInfoForType(
                            { type: 'date' },
                            reqAttachmentDetails.req_attachments_dates[`${photo.attachmentFieldName}_date`]
                          )}
                      )
                      </span>
                    )}
                    {badgeExpiryDate !== null && (
                      <span style={{ fontSize: '16px', fontWeight: 'normal' }}> (
                        <FormattedMessageWithClass
                          tagname="span"
                          id="exipres.on"
                          defaultMessage={'Expires On'}
                          />
                          : {renderInfoForType({ type: 'date' }, badgeExpiryDate)}
                          )
                      </span>
                    )}
                  </h3>
                  <a href={photo.url || photo.preview || photo.image} target="_blank" rel="noopener noreferrer">
                    <Button
                      translationID="documents.version.download"
                      defaultText="Download"
                      action="secondary"
                      style={{ color: '#e6eaee' }}
                      formsDetails={formsDetails}
                    />
                  </a>
                </div>
              <DocumentViewer
                style={{ width: '650px', height: '100%' }}
                queryParams="en"
                url={photo.url || photo.image || photo.preview}
                overrideLocalhost="https://react-doc-viewer.firebaseapp.com/"
                viewer={photo.preview ? 'pdf' : 'google'}
              />
            </div>
          </div>
        );
      }
      if (isAudioVideo) {
        return (
          <div>
            <div className={styles.slider}>
              <div className="d-flex justify-content-between" style={{ width: formsDetails && '100%',
                maxWidth: formsDetails && '100%',
                marginBottom: formsDetails && '10px' }}>
                <h3>{photo.file_name || photo.name}</h3>
                <a href={photo.url || photo.preview || photo.image} target="_blank" rel="noopener noreferrer">
                  <Button
                    translationID="documents.version.download"
                    defaultText="Download"
                    action="secondary"
                    style={{ color: '#e6eaee' }}
                    formsDetails={formsDetails}
                  />
                </a>
              </div>
              <ReactPlayer
                url={photo.url}
                width="100%"
                height="550px"
                controls
                playing={this.handlePause(i)}
              />
            </div>
          </div>
        );
      }
        return null;
    };
    return (
      <>
        <div className={`${styles.mainCarousel} ${styles.centeredSlides}`}>
          <Slider
            asNavFor={this.imageNav.current}
            ref={this.mainCarousel}
            initialSlide={initialSlide}
            nextArrow={<NextPhotoArrow />}
            prevArrow={<PrevPhotoArrow />}
            beforeChange={(cur, next) => { this.setState({ currIndex: next }); }}
            draggable={!formsDetails}
          >
            {attachments?.map((photo, i) => (
              <div key={photo.id}>
                {renderFiles(photo, i)}
              </div>
            ))}
          </Slider>
        </div>
      </>
    );
  }
}

FileSlider.defaultProps = {
  initialSlide: 0
};

FileSlider.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  initialSlide: PropTypes.number
};

export default FileSlider;
